import PermissionUtil from './PermissionUtil'

class InsertionOrderAuthModel {
  constructor({ id, name, parentId, permission }) {
    this.id = id
    this.name = name
    this.permission = permission
    this.advertiserAuthModel = null
  }
  setAdvertiserAuthModel(advertiserAuthModel) {
    this.advertiserAuthModel = advertiserAuthModel
  }
  // inheritかどうかを判定する
  getInheritFlg() {
    if (this.permission === 'inherit') return true
    return false
  }
  // 自分自身がreadonly権限以上かどうか
  isMoreReadonly() {
    return PermissionUtil.isMoreReadonly(this.getPermission())
  }
  getPermission() {
    if (this.permission === 'inherit') {
      return this.advertiserAuthModel.getPermission()
    } else {
      return this.permission
    }
  }
  // 自分自身が変わった時
  // 親にも通知
  setPermission(permission) {
    this.permission = permission
    this.advertiserAuthModel.notify()
  }
}
export default InsertionOrderAuthModel
